import { render, staticRenderFns } from "./RolesPorDefecto.vue?vue&type=template&id=9ceda136&scoped=true&"
import script from "./RolesPorDefecto.vue?vue&type=script&lang=js&"
export * from "./RolesPorDefecto.vue?vue&type=script&lang=js&"
import style0 from "./RolesPorDefecto.vue?vue&type=style&index=0&id=9ceda136&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ceda136",
  null
  
)

export default component.exports